import { Fragment, useEffect, useState } from 'react';

import { serialize } from '@playbooks/api';
import { CollectionAbbreviatedFields } from '@playbooks/components/collection/collection-abbreviated-fields';
import { useStore, useWorkspace } from '@playbooks/contexts';
import { useSave } from '@playbooks/hooks';
import { Button } from '@playbooks/ui/components/button';
import { DialogFooter, DialogHeader, DialogTitle } from '@playbooks/ui/components/dialog';
import { Icon } from '@playbooks/ui/components/icon';
import { logger } from '@playbooks/utils';

const CollectionFlowForm = ({ model, onClose, onPrev, onNext }) => {
	const [collection, setCollection] = useState<any>({});
	const workspace = useWorkspace();
	const store = useStore();

	// Hooks
	useEffect(() => {
		setCollection(model);
	}, [model]);

	useEffect(() => {
		logger.debug('collection: ', collection);
	}, [collection]);

	// Actions
	const [onSave, saveTask] = useSave('collection', async () => {
		const response = await store.saveRecord({
			url: collection.id ? `${workspace.rootApi}/collections/${collection.uuid}` : `${workspace.rootApi}/collections`,
			data: serialize(collection, ['name', 'description', 'position', 'bookmarks.id']),
		});
		onNext(response.data);
	});

	// Methods
	const onSubmit = e => {
		e.preventDefault();
		onSave();
	};

	// Render
	return (
		<Fragment>
			<form onSubmit={onSubmit}>
				<DialogHeader>
					<DialogTitle className='gap-4 flex-start'>
						<Button variant='outline' size='icon' aria-label='Back' onClick={onPrev} className='text-lg'>
							<Icon data-icon='inline-start' type='far' icon='chevron-left' aria-hidden />
						</Button>
						<span>Add Collection</span>
					</DialogTitle>
				</DialogHeader>
				<div>
					<CollectionAbbreviatedFields collection={collection} setCollection={setCollection} />
				</div>
				<DialogFooter>
					<Button variant='secondary' onClick={onPrev}>
						Cancel
					</Button>
					<Button type='submit' isLoading={saveTask.running}>
						Save
					</Button>
				</DialogFooter>
			</form>
		</Fragment>
	);
};

export { CollectionFlowForm };
